// Import your custom list group entries.
import props from "./parts/props";

import { is } from "bpmn-js/lib/util/ModelUtil";

const LOW_PRIORITY = 700;

/**
 * A provider with a `#getGroups(element)` method
 * that exposes groups for a diagram element.
 *
 * @param {PropertiesPanel} propertiesPanel
 * @param {Function} translate
 */
export default function documentsPropertiesProvider(
  propertiesPanel,
  injector,
  translate
) {
  // API ////////

  /**
   * Return the groups provided for the given element.
   *
   * @param {DiagramElement} element
   *
   * @return {(Object[]) => (Object[])} groups middleware
   */
  this.getGroups = function (element) {
    /**
     * We return a middleware that modifies
     * the existing groups.
     *
     * @param {Object[]} groups
     *
     * @return {Object[]} modified groups
     */
    return function (groups) {
      // console.log("hiiiiii+++",element,groups)
      // if (!is(element, "bpmn:Process")) {
        groups.push(createParametersGroup(element, injector, translate));
      // }

      return groups;
    };
  };

  // registration ////////

  // Register our custom documents properties provider.
  // Use a lower priority to ensure it is loaded after
  // the basic BPMN properties.
  propertiesPanel.registerProvider(LOW_PRIORITY, this);
}

documentsPropertiesProvider.$inject = [
  "propertiesPanel",
  "injector",
  "translate",
];

// Create the custom parameters list group.
function createParametersGroup(element, injector, translate) {
  // Create a group called "parameters".
  const parametersGroup = {
    id: "parameters",
    label: translate("Comments"),
    entries: props(element),
  };

  return parametersGroup;
}
